import './styles.scss';

import { Spacer, Stack, Text } from '@kolonialno/lama';
import { type PropsWithChildren } from 'react';

import { Logo } from '../Logo';
import { OdaSystemsLogo } from '../OdaSystemsLogo';

type ContainerProps = {
    title?: string;
    odaSystemsLogo?: boolean;
};

function Container({
    title,
    children,
    odaSystemsLogo = false,
}: PropsWithChildren<ContainerProps>) {
    return (
        <div className="authentication">
            <Stack
                className="container"
                justifyContent="center"
                alignItems="center"
                direction="vertical"
            >
                <Stack alignItems="center" className="inner-container">
                    <Stack
                        direction="vertical"
                        spacing="xs"
                        alignItems="center"
                    >
                        <Logo style={{ height: 24, width: 'auto' }} />

                        {title && (
                            <>
                                <Spacer spacing="xs" />
                                <Text
                                    variant="subtitle1"
                                    className="white-text"
                                    alignment="center"
                                >
                                    {title}
                                </Text>
                            </>
                        )}
                    </Stack>

                    {children}

                    {odaSystemsLogo && (
                        <Stack alignItems="center" spacing="xs">
                            <Text variant="body2" className="white-text">
                                Powered by
                            </Text>
                            <OdaSystemsLogo />
                        </Stack>
                    )}
                </Stack>
            </Stack>
        </div>
    );
}

export default Container;
